import { render } from "./CrossCropSeedserviceIcon.vue?vue&type=template&id=92625e06"
import script from "./CrossCropSeedserviceIcon.vue?vue&type=script&lang=js"
export * from "./CrossCropSeedserviceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__